import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { getStore } from 'utils/localStorage';
import EnumsManager from 'utils/EnumsManager';
import { LoginForm, ForgotPassword, ResetPassword, CheckEmail, HasBeenReset } from 'views/index';

const { LocalStorageKey } = EnumsManager;

class mainContentView extends Component {
  componentDidMount() {
    this.destroyEcho();
  }

  // Disconnect and destroy Echo
  destroyEcho = () => {
    if (_.isObject(window.Echo)) {
      window.Echo.disconnect();
      delete window.Echo;
    }
  };

  render() {
    const { loginUser } = this.props;
    const { historyPath } = loginUser;
    const localLoginUser = getStore(LocalStorageKey);
    if (localLoginUser) {
      return _.isEmpty(historyPath) ? <Redirect to="/" /> : <Redirect to={historyPath} />;
    }
    return (
      <Switch>
        <Route path="/auth/login" component={LoginForm} />
        <Route path="/auth/forgotPassword" exact component={ForgotPassword} />
        <Route path="/auth/forgotPassword/checkEmail" component={CheckEmail} />
        <Route path="/auth/resetPassword" component={ResetPassword} />
        <Route path="/auth/resetSuccessfully" component={HasBeenReset} />
      </Switch>
    );
  }
}

const mapStateToProps = ({ global, loginUser }) => ({
  lang: global.language,
  loginUser
});

export default withRouter(connect(mapStateToProps)(mainContentView));



// WEBPACK FOOTER //
// ./src/components/page/AuthMainContent/index.js